(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-sizing-ai"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.apolla-sizing-ai');
    roots.forEach(function (root) {
      if (root.dataset.initialized === 'true') {
        return;
      }
      root.dataset.initialized = 'true';
      // Phase 2 Tasks 2.2 + 2.3 will attach the form state machine and SSE consumer here.
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizing-ai-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.apolla-sizing-ai-page');
    if (!root) return;

    var endpoint = root.dataset.endpoint;
    var trigger = root.querySelector('.apolla-sizing-ai-page__trigger');
    var panel = root.querySelector('.apolla-sizing-ai-page__panel');
    var form = root.querySelector('.apolla-sizing-ai-page__form');
    var submit = root.querySelector('.apolla-sizing-ai-page__submit');
    var loading = root.querySelector('.apolla-sizing-ai-page__loading');
    var answer = root.querySelector('.apolla-sizing-ai-page__answer');
    var answerProse = root.querySelector('.apolla-sizing-ai-page__answer-prose');
    var answerCta = root.querySelector('.apolla-sizing-ai-page__answer-cta');
    var restart = root.querySelector('.apolla-sizing-ai-page__restart');
    var errorBox = root.querySelector('.apolla-sizing-ai-page__error');
    var errorMsg = root.querySelector('.apolla-sizing-ai-page__error-msg');
    var productSelect = root.querySelector('#apolla-sizing-ai-page-product');

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });

    function fetchVariants(handle) {
      return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var seenSizes = {};
          var dedup = [];
          (product.variants || []).forEach(function (v) {
            var sizeKey = '';
            (product.options || []).forEach(function (opt, i) {
              if (String(opt).toLowerCase() === 'size') {
                sizeKey = v['option' + (i + 1)];
              }
            });
            if (!sizeKey || seenSizes[sizeKey]) return;
            seenSizes[sizeKey] = true;
            dedup.push({
              id: String(v.id),
              title: v.title,
              size: sizeKey,
              available: !!v.available,
              price: (v.price / 100).toFixed(2)
            });
          });
          return { product: product, variants: dedup };
        });
    }

    async function handleSubmit(e) {
      e.preventDefault();
      errorBox.hidden = true;
      submit.disabled = true;
      form.hidden = true;
      loading.hidden = false;
      answer.hidden = true;

      var data = new FormData(form);
      var handle = data.get('product_handle');
      if (!handle) {
        showError('Please pick a style first.');
        return;
      }

      try {
        var pkg = await fetchVariants(handle);
        var payload = {
          product_handle: handle,
          product_id: String(pkg.product.id),
          available_variants: pkg.variants,
          structured_answers: {
            shoe_size: data.get('shoe_size') || '',
            shoe_size_gender: data.get('shoe_size_gender') || 'womens',
            foot_width: data.get('foot_width') || 'average',
            freetext: data.get('freetext') || ''
          }
        };

        var response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!response.ok || !response.body) {
          throw new Error('Unexpected response: ' + response.status);
        }

        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';
        var prose = '';
        var recommendation = null;

        loading.hidden = true;
        answer.hidden = false;
        answerProse.innerHTML = '';

        while (true) {
          var chunk = await reader.read();
          if (chunk.done) break;
          buffer += decoder.decode(chunk.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop() || '';
          for (var i = 0; i < lines.length; i++) {
            var line = lines[i].trim();
            if (!line.startsWith('data:')) continue;
            try {
              var obj = JSON.parse(line.slice(5).trim());
              if (obj.type === 'token' && obj.text) {
                prose += obj.text;
                answerProse.innerHTML = renderProse(prose);
              } else if (obj.type === 'recommendation') {
                recommendation = obj;
              }
            } catch (err) { /* skip malformed */ }
          }
        }

        // Final parse: extract RECOMMENDATION block from prose if present
        var recMatch = prose.match(/<!--\s*RECOMMENDATION\s*-->\s*(\{[^<]*?\})/);
        if (recMatch) {
          try { recommendation = JSON.parse(recMatch[1]); } catch (e) { /* ignore */ }
          // Strip the recommendation block from displayed prose
          prose = prose.replace(/<!--\s*RECOMMENDATION\s*-->[\s\S]*?<!--\s*\/RECOMMENDATION\s*-->/, '').trim();
          answerProse.innerHTML = renderProse(prose);
        }

        if (recommendation && recommendation.size) {
          var productTitle = productSelect.options[productSelect.selectedIndex].dataset.title || handle;
          var sizeLabel = recommendation.size;
          answerCta.innerHTML =
            '<span class="apolla-sizing-ai-page__answer-size-label">Your size in the ' + escapeHtml(productTitle) + '</span>' +
            '<span class="apolla-sizing-ai-page__answer-size">' + escapeHtml(sizeLabel) + '</span>' +
            '<a class="apolla-sizing-ai-page__pdp-link" href="/products/' + encodeURIComponent(handle) + '">Take me to the ' + escapeHtml(productTitle) + ' →</a>';
          answerCta.hidden = false;
        } else {
          answerCta.hidden = true;
        }

      } catch (err) {
        showError('Sorry — something went wrong. ' + (err && err.message ? err.message : ''));
      } finally {
        submit.disabled = false;
      }
    }

    function showError(msg) {
      loading.hidden = true;
      form.hidden = false;
      errorBox.hidden = false;
      errorMsg.textContent = msg;
    }

    function renderProse(text) {
      // Minimal markdown rendering: bold + paragraphs
      var html = escapeHtml(text)
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/\n\n+/g, '</p><p>')
        .replace(/\n/g, '<br>');
      return '<p>' + html + '</p>';
    }

    form.addEventListener('submit', handleSubmit);
    restart.addEventListener('click', function () {
      form.hidden = false;
      answer.hidden = true;
      errorBox.hidden = true;
      answerProse.innerHTML = '';
      answerCta.innerHTML = '';
      answerCta.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
